import React from "react";
import { useFormikContext } from "formik";
import { FormikInput } from "components/common";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import {
  DATA_TIERING_LICENSE_TITLE,
  DATA_TIERING_LICENSE_TEXT,
  DATA_TIERING_UPSELL_TITLE,
  DATA_TIERING_UPSELL_TEXT
} from "data-tiering/constants";
import useDataTiering from "./hooks/useDataTiering";
import RepositoryManagement from "./RepositoryManagement";
import WarmTierReadinessInfo from "./WarmTierReadinessInfo";
const TiersConfigurationFields = ({
  valuesPrefix = void 0,
  hiddenFields = [],
  immutableFields = [],
  ignoreFieldRestrictions = true
}) => {
  var _a;
  const { readiness } = useDataTiering();
  const { values } = useFormikContext();
  const sectionDisabled = immutableFields.includes("data_tiering");
  const formValue = (field) => {
    var _a2, _b, _c;
    if (valuesPrefix) {
      return (_b = (_a2 = values[valuesPrefix]) == null ? void 0 : _a2.data_tiering) == null ? void 0 : _b[field];
    }
    return (_c = values == null ? void 0 : values.data_tiering) == null ? void 0 : _c[field];
  };
  const fieldName = (field) => {
    if (valuesPrefix) {
      return `${valuesPrefix}.data_tiering.${field}`;
    }
    return `data_tiering.${field}`;
  };
  const validateMinDaysInHotTier = (value) => {
    const errors = [];
    if (value < 0) {
      errors.push("Negative numbers are not allowed.");
    }
    if (value > formValue("index_lifetime_min")) {
      errors.push("Min. days in hot tier needs to be smaller than min. days in storage.");
    }
    if (errors.length > 0) {
      return errors.join(" ");
    }
    return "";
  };
  const shouldRenderWarmTierReadinessInfo = () => {
    if (ignoreFieldRestrictions || formValue("warm_tier_enabled")) return true;
    if (immutableFields.includes("data_tiering.warm_tier_enabled") || hiddenFields.includes("data_tiering.warm_tier_enabled"))
      return false;
    return true;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, shouldRenderWarmTierReadinessInfo() && /* @__PURE__ */ React.createElement(WarmTierReadinessInfo, null), ((_a = readiness.data) == null ? void 0 : _a.ready) && /* @__PURE__ */ React.createElement(React.Fragment, null, formValue("warm_tier_enabled") ? /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: DATA_TIERING_LICENSE_TEXT,
      title: DATA_TIERING_LICENSE_TITLE,
      licenseSubject: LICENSE_SUBJECTS.enterprise,
      bsStyle: "danger"
    }
  ) : /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: DATA_TIERING_UPSELL_TEXT,
      title: DATA_TIERING_UPSELL_TITLE,
      licenseSubject: LICENSE_SUBJECTS.enterprise
    }
  ), (!hiddenFields.includes("data_tiering.warm_tier_enabled") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      id: "data-tiering-warm-tier-enabled",
      label: "Enable Warm Tier",
      name: fieldName("warm_tier_enabled"),
      help: "Enable Warm Tier and use Searchable Snapshots?",
      disabled: (immutableFields.includes("data_tiering.warm_tier_enabled") || sectionDisabled) && !ignoreFieldRestrictions
    }
  ), formValue("warm_tier_enabled") && /* @__PURE__ */ React.createElement(React.Fragment, null, (!hiddenFields.includes("data_tiering.index_hot_lifetime_min") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "number",
      id: "data-tiering-index-hot_lifetime_min",
      label: "Min. days in Hot Tier",
      name: fieldName("index_hot_lifetime_min"),
      min: 0,
      max: formValue("index_lifetime_min"),
      validate: (value) => validateMinDaysInHotTier(parseInt(value, 10)),
      help: "How many days at minimum your data should be stored in the Hot Tier?",
      disabled: (immutableFields.includes("data_tiering.index_hot_lifetime_min") || sectionDisabled) && !ignoreFieldRestrictions,
      required: true
    }
  ), (!hiddenFields.includes("data_tiering.warm_tier_repository_name") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    RepositoryManagement,
    {
      valuesPrefix,
      disabled: (immutableFields.includes("data_tiering.warm_tier_repository_name") || sectionDisabled) && !ignoreFieldRestrictions
    }
  ))));
};
export default TiersConfigurationFields;
